import { createContext, useContext, useState, useEffect, useCallback } from "react";

const AdminAuthContext = createContext(null);

export const useAdminAuth = () => useContext(AdminAuthContext);

const STORAGE_KEY = "hplAdminToken";
const ADMIN_INFO_KEY = "hplAdminInfo";

export function AdminAuthProvider({ children }) {
  const [adminToken, setAdminToken] = useState(null);
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEY);
    const info = localStorage.getItem(ADMIN_INFO_KEY);

    if (token) {
      // Check if token is expired
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.exp * 1000 > Date.now()) {
          setAdminToken(token);
          if (info) setAdminInfo(JSON.parse(info));
        } else {
          // Token expired, clear it
          localStorage.removeItem(STORAGE_KEY);
          localStorage.removeItem(ADMIN_INFO_KEY);
        }
      } catch {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(ADMIN_INFO_KEY);
      }
    }
    setLoading(false);
  }, []);

  const loginAdmin = (token, info) => {
    setAdminToken(token);
    setAdminInfo(info);
    localStorage.setItem(STORAGE_KEY, token);
    localStorage.setItem(ADMIN_INFO_KEY, JSON.stringify(info));
  };

  const logoutAdmin = useCallback(() => {
    setAdminToken(null);
    setAdminInfo(null);
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(ADMIN_INFO_KEY);
  }, []);

  const getAdminHeaders = useCallback(
    () => ({
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    }),
    [adminToken],
  );

  const isAdminAuthenticated = !!adminToken;

  return (
    <AdminAuthContext.Provider
      value={{
        adminToken,
        adminInfo,
        isAdminAuthenticated,
        loading,
        loginAdmin,
        logoutAdmin,
        getAdminHeaders,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
}
